/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Start_Page_Account_BodyInputs */

const en_start_page_account_body = /** @type {(inputs: Start_Page_Account_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free, with no card. You get your own page with your services, prices and free times, ready to send.`)
};

const pl_start_page_account_body = /** @type {(inputs: Start_Page_Account_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bezpłatnie i bez karty. Dostajesz własną stronę z usługami, cenami i wolnymi terminami, gotową do wysłania.`)
};

/**
* | output |
* | --- |
* | "Free, with no card. You get your own page with your services, prices and free times, ready to send." |
*
* @param {Start_Page_Account_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const start_page_account_body = /** @type {((inputs?: Start_Page_Account_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Start_Page_Account_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_start_page_account_body(inputs)
	return en_start_page_account_body(inputs)
});